/** Internal lane ids (API): payouts | combined | jackpots */

export function evidenceLaneLabel(laneId) {
  switch (laneId) {
    case 'payouts':
      return 'Payout'
    case 'combined':
      return 'Transactions'
    case 'jackpots':
      return 'Jackpots'
    default:
      return laneId || ''
  }
}

export function evidenceItemTypeLabel(type) {
  switch (type) {
    case 'payout':
      return 'Payout'
    case 'combined_session':
      return 'Session'
    case 'combined_interval':
      return 'Interval'
    case 'slot_jackpot':
      return 'Slot jackpot'
    case 'session':
      return 'Session'
    case 'transaction':
      return 'Transaction'
    default:
      return type || 'Item'
  }
}

export function evidenceLinkedTypeLabel(item) {
  const n = item || {}
  const isCombinedSession =
    n._evidence_item_type === 'combined_session' || n.evidence_category === 'combined_session'
  const isCombinedInterval =
    n._evidence_item_type === 'combined_interval' || n.evidence_category === 'combined_interval'
  const isSlotJackpot =
    n._evidence_item_type === 'slot_jackpot' ||
    n.evidence_category === 'slot_jackpot' ||
    n._evidence_source_table === 'fact_slot_analysis_daily'
  const isPayout =
    Boolean(n.payout_id || n.PayoutID || n.payoutId) ||
    n._evidence_item_type === 'payout' ||
    n._evidence_source_table === 'payout_records'
  const isSession =
    Boolean(n.SessionPK || n.session_id) &&
    !isCombinedSession &&
    !isCombinedInterval &&
    !isSlotJackpot

  if (isPayout) return 'Payout'
  if (isCombinedSession || isSession) return 'Session'
  if (isCombinedInterval) return 'Interval'
  if (isSlotJackpot) return 'Slot jackpot'
  return 'Transaction'
}

export function evidenceLinkReasonFromItem(it) {
  if (it?._link_reason) return it._link_reason
  if (it?.source === 'alert' || it?._from_alert) return 'Triggering alert (gaming event)'
  if (it?._evidence_item_type === 'combined_session' || it?.evidence_category === 'combined_session') {
    return 'Linked session'
  }
  if (it?._evidence_item_type === 'combined_interval' || it?.evidence_category === 'combined_interval') {
    return 'Linked interval'
  }
  if (it?._evidence_item_type === 'slot_jackpot' || it?.evidence_category === 'slot_jackpot') {
    return 'Linked slot jackpot (EGM-day)'
  }
  if (it?._evidence_item_type === 'payout' || it?.payout_id) return 'Linked payout'
  if (it?._evidence_source_table === 'payout_records' || it?.PayoutID) return 'Linked payout'
  if (it?._evidence_item_type === 'session' || it?.SessionPK || it?.session_id) {
    return 'Linked gaming session'
  }
  if (it?._evidence_source_table === 'gaming_transactions' || it?._evidence_item_type === 'transaction') {
    return 'Linked gaming transaction'
  }
  if (it?._evidence_source_table === 'manual') return 'Manually linked'
  if (it?.source === 'payout') return 'Triggering payout (opened case)'
  return 'Linked to investigation'
}

/** Truncate long session/transaction ids for table cells */
export function formatEvidenceRowId(raw, maxLen = 28) {
  const s = String(raw || '').trim()
  if (!s || s === '—') return '—'
  if (s.includes('|')) {
    const [head] = s.split('|')
    return head.length > maxLen ? `${head.slice(0, maxLen)}…` : head
  }
  return s.length > 32 ? `${s.slice(0, 32)}…` : s
}

export function evidenceEmptyMessage(lane, combinedView) {
  if (lane === 'payouts') {
    return 'No payouts found for this date range. Add a membership # or player ID to narrow results.'
  }
  if (lane === 'jackpots') {
    return 'No slot jackpots found for this date range. Add an EGM # to narrow, or import Slot Analysis data.'
  }
  if (combinedView === 'session') {
    return 'No transactions found for this date range. Add a membership #, player ID, or EGM to narrow, or run Process & Combine for this period.'
  }
  return 'No transaction intervals found for this date range.'
}
